let navMenu = document.getElementById('lp-nav-menu');
let hamburger = document.getElementById('lp-hamburger');
let navItems = document.querySelectorAll('#lp-nav-menu a');

// Toggle active class when the hamburger icon is clicked
hamburger.addEventListener('click', function() {
    navMenu.classList.toggle('active');
    hamburger.classList.toggle('active');
});

// Remove active class when any nav item is clicked
navItems.forEach(function(item) {
    item.addEventListener('click', function() {
        navMenu.classList.remove('active');
        hamburger.classList.remove('active');
    });
});
